<h1
  class="text-[24px] font-bold text-[#353C40] pl-0 md:pl-2 w-full md:w-auto md:flex-1">
  {{ court().clerk?.name }} - {{ court().name }}
</h1>
